import api from './axiosConfig.js'

export const attendanceApi = {
  // Attendance logs
  getOrgAttendance: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/org/attendance', {
      params,
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  },

  getAttendanceLogs: (params = {}) =>
    api.get('/attendance/logs/logs', { params }),

  getAttendanceLog: (logId) =>
    api.get(`/attendance/logs/logs/${logId}`),

  deleteAttendanceLog: (logId) =>
    api.delete(`/attendance/logs/logs/${logId}`),

  // Attendance summary
  getDailySummary: (params = {}) =>
    api.get('/attendance/summary/daily', { params }),

  getMonthlyReport: (params = {}) =>
    api.get('/attendance/summary/monthly', { params }),

  getEmployeeAttendance: (employeeId, params = {}) =>
    api.get(`/attendance/summary/summary/${employeeId}`, { params }),

  markAttendance: (data) =>
    api.post('/employee/attendance/mark', data, { skipSuccessToast: true }),

  getTodayAttendance: (headers = {}) =>
    api.get('/employee/attendance/today', { headers }),

  getAttendanceHistory: (params = {}, headers = {}) =>
    api.get('/employee/attendance/history', { params, headers }),

  getEmployeeAttendanceStats: (employeeId) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/org/employee/attendance/stats', {
      params: { employee_id: employeeId },
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  },

  getEmployeePerformanceChart: (employeeId) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/org/employee/attendance/performance-chart', {
      params: { employee_id: employeeId },
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  },

  getWeeklyAttendanceHours: (headers = {}) =>
    api.get('/employee/dashboard/weekly-attendance-hours', { headers }),

  getEmployeeStats: (headers = {}) =>
    api.get('/attendance/summary/get-employee-stats', { headers }),

  getAttendanceSummary: (headers = {}) =>
    api.get('/attendance/summary/attendance-summary', { headers }),

  getMonthlyAttendanceOverview: (headers = {}) =>
    api.get('/attendance/summary/monthly-attendance-overview', { headers }),
}